import { OpenLRGeoCoordinate } from './openlrgeocoordinate.model';
import { OpenLRPointAlongLine } from './openlrpointalongline.model';

export class OpenLRPointLocationReference {
  openlrPointAlongLine: OpenLRPointAlongLine;
  openlrGeoCoordinate: OpenLRGeoCoordinate;
}



// WEBPACK FOOTER //
// ./src/app/models/openlr/openlrpointlocationreference.model.ts